import React from "react";
import { classNames } from "../../../utils/helpers";
import { useRCSHealth } from "../hooks/useRCSHealth";
import { useHealthApi, useHealthApiModal } from "../hooks/useHealthApi";
import { FormatInt } from "../../../utils/FormatData";
import Icon from "../../../components/Icon";
import { Tooltip } from "../../../components/ui/Tooltip";
import _ModalRCSHealthApi from "./modal/_ModalRCSHealthApi";
import _Button from "../../../components/generic/_Button";
import CardSkeleton from "../../../components/ui/Skeleton/CardSkeleton";
const RCSHealthApi = () => {
  const { data, isPending: loading, isFetching } = useRCSHealth();

  const { pending, received, sent, errors } = useHealthApi(data);

  const { visible, onOpen, onClose } = useHealthApiModal();

  if (loading || isFetching) return <CardSkeleton />;

  return (
    <div
      className={classNames(
        "flex flex-col px-4 py-2 transition-all duration-300 transform rounded-lg hover:scale-105",
        {
          "bg-green-50": pending === 0,
          "bg-red-50": pending > 100,
          "bg-yellow-50": pending > 0 && pending < 100,
        },
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <div
          className={classNames(
            "text-lg font-bold text-green-700 dark:text-background-light pb-3",
            {
              "text-green-700": pending === 0,
              "text-red-700": pending > 100,
              "text-yellow-700": pending > 0 && pending < 100,
            },
          )}
        >
          Mensajes API por procesar
        </div>
        <Icon
          icon="api"
          className={classNames({
            "text-green-600": pending === 0,
            "text-red-600": pending > 100,
            "text-yellow-600": pending > 0 && pending < 100,
          })}
          size={36}
        />
      </div>

      <p
        className={classNames(
          `mt-2 text-3xl font-bold text-[#101922] dark:text-background-light`,
          {
            "text-green-700": pending === 0,
            "text-red-700": pending > 100,
            "text-yellow-700": pending > 0 && pending < 100,
          },
        )}
      >
        {FormatInt(pending)}
      </p>

      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
        <Tooltip message="Mensajes enviados" placement="top">
          <div className="flex items-center gap-1 text-slate-700">
            <span className="material-symbols-outlined">arrow_upward_alt</span>
            <span>{FormatInt(sent)}</span>
          </div>
        </Tooltip>

        <Tooltip message="Mensajes recibidos" placement="top">
          <div className="flex items-center gap-1 text-slate-700">
            <span className="material-symbols-outlined">
              arrow_downward_alt
            </span>
            <span>{FormatInt(received)}</span>
          </div>
        </Tooltip>
        <Tooltip message="Mensajes con error" placement="top">
          <div className="flex items-center gap-1 text-red-700">
            <span className="material-symbols-outlined">error</span>
            <span>{FormatInt(errors)}</span>
          </div>
        </Tooltip>
      </div>

      <_Button
        icon="read_more"
        style="none"
        styleIcon="outlined"
        title="Ver Detalles"
        onClick={onOpen}
        className="p-0 mt-[5px]"
      />
      <_ModalRCSHealthApi
        visible={visible}
        title="Detalles API"
        onClose={onClose}
      />
    </div>
  );
};

export default RCSHealthApi;
